<div class="themed-dialog" (scroll)="onScroll($event)">
  <div class="dialog__header">
    <div class="dialog__header__top">
      <div class="top__left">
        <h2 class="title__text" tabindex="0">{{ 'external.youtube.title' | translate }}</h2>
        <div class="title__icon">
          <span class="odilo-icon" aria-hidden="true">youtube</span>
          <span *ngIf="hasResults" class="count" aria-hidden="true">{{ numResultsLabel }}</span>
        </div>
      </div>
      <div class="top__right">
        <button
          mat-flat-button
          class="only-icon title__close"
          (click)="dialogRef.close()"
          [attr.aria-label]="'common.close' | translate">
          <span class="odilo-icon" aria-hidden="true">close</span>
        </button>
      </div>
    </div>

    <div class="dialog__header__search">
      <form [formGroup]="searchForm" class="search-bar">
        <mat-form-field>
          <input
            #queryField="matInput"
            type="text"
            aria-labelledby="searchButton"
            matInput
            formControlName="query"
            (click)="$event.stopPropagation()" />
          <button
            id="searchButton"
            matSuffix
            mat-icon-button
            [attr.aria-label]="'tooltip.search' | translate"
            (click)="submit()">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </form>

      <div class="search-terms">
        <mat-chip-list *ngIf="searchModel" [attr.aria-label]="'searches.title' | translate">
          <mat-chip
            *ngFor="let term of searchModel.terms"
            [selectable]="false"
            [removable]="true"
            (keydown.enter)="removeTerm(term)"
            (keydown.space)="removeTerm(term)"
            [attr.aria-label]="term.term"
            (removed)="removeTerm(term)">
            <span class="odilo-icon" aria-hidden="true">{{ term.icon }}</span>
            <span aria-hidden="true">{{ term.term }}</span>
            <span matChipRemove class="odilo-icon close-icon" aria-hidden="true">close</span>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </div>

  <div class="dialog__content">
    <div class="dialog__content__grid" *ngIf="hasResults">
      <div class="grid-item" *ngFor="let item of youtubeItems">
        <app-youtube-item [youtubeItem]="item" (videodata)="openVideoDialog($event)"></app-youtube-item>
      </div>
    </div>

    <div class="loading-animation" *ngIf="searching">
      <div class="animation-row">
        <div class="double-bounce">
          <div class="child double-bounce1"></div>
          <div class="child double-bounce2"></div>
        </div>
      </div>
    </div>

    <opac-no-results *ngIf="!hasResults" [label]="noResultsText | translate">
      <opac-no-results-results slot="custom-svg"></opac-no-results-results>
    </opac-no-results>
  </div>
</div>
